import { lazyLoadWithRetry } from "utilities/react.utilities";
import { routes } from "utilities/routes";

import { BTSuspense } from "commonComponents/btWrappers/BTSuspense/BTSuspense";
import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

import { type ISelectionChoiceProps } from "entity/selectionChoice/SelectionChoice/SelectionChoice";

const SelectionChoice = lazyLoadWithRetry(() => import("./SelectionChoice"));

type RouteSelectionChoiceProps = Omit<
    ISelectionChoiceProps,
    "id" | "jobId" | "history" | "location" | "match" | "modalConfig" | "onClose"
> &
    (
        | (Required<Pick<ISelectionChoiceProps, "modalConfig">> &
              Pick<ISelectionChoiceProps, "onClose">)
        | (Required<Pick<ISelectionChoiceProps, "onClose">> &
              Pick<ISelectionChoiceProps, "modalConfig">)
    );

export const RouteSelectionChoice = (props: RouteSelectionChoiceProps) => (
    <RouteRelative
        path={routes.selectionChoice.details}
        render={(routeProps) => {
            return (
                <BTSuspense>
                    <SelectionChoice
                        {...props}
                        {...routeProps}
                        id={parseInt(routeProps.match.params.choiceId)}
                        jobId={parseInt(routeProps.match.params.jobId)}
                        selectionId={
                            routeProps.match.params.selectionId
                                ? parseInt(routeProps.match.params.selectionId)
                                : undefined
                        }
                    />
                </BTSuspense>
            );
        }}
    />
);
